import template from './typeahead-dropdown.html';
import tripEvents from './../../trip/config/events.constant.js';


const DIRECTIVE_NAME = TypeaheadDropdown.DIRECTIVE_NAME = 'ktTypeaheadDropdown';
export default function TypeaheadDropdown() {
    return {
        restrict: 'A',
        controller: TypeaheadDropdownController,
        controllerAs: '$ctrl',
        template,
        bindToController: true,
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            list: `=${DIRECTIVE_NAME}List`,
            filterType: `@${DIRECTIVE_NAME}FilterType`,
            requiredValidationMessage: `@${DIRECTIVE_NAME}RequiredValidationMessage`,
            tabIndex: `@${DIRECTIVE_NAME}TabIndex`,
            required: `=${DIRECTIVE_NAME}IsRequired`,
            id: `@${DIRECTIVE_NAME}CodeId`,
            approverOverride: `@${DIRECTIVE_NAME}ApproverOverride`,
        },
        link,
    };

    function link($scope, $elem, $attrs, typeaheadDropdownCtrl) {
        typeaheadDropdownCtrl.$onInit();
    }
}

export function TypeaheadDropdownController(
    $scope,
    $rootScope,
) {
    'ngInject';
    const vm = this;
    const FILTER_CONTAINS = 'contains';
    const REQUIRED_DEFAULT = true;
    const INITIAL_ITEMS_COUNT = 100;
    const NUMBER_OF_ITEMS_TO_ADD = 100;
    vm.approverOverride = false;

    Object.assign(vm, {
        $onInit,
        startsWith,
        contains,
        loadMoreItems,
        filterItems,
        onOpenClose,
        infiniteScroll: {
            numberToAdd: NUMBER_OF_ITEMS_TO_ADD,
        },
        checkPaymentCode,
    });

    function $onInit() {
        vm.isFilterTypeContains = !!vm.filterType && vm.filterType === FILTER_CONTAINS;
        vm.isRequired = angular.isDefined(vm.required) ? vm.required : REQUIRED_DEFAULT;
        vm.infiniteScroll.listLimit = initListLimit();
        vm.disableSearch = true;
    }


    function filterItems(search) {
        return vm.isFilterTypeContains ? vm.contains(search) : vm.startsWith(search);
    }

    function startsWith(letter) {
        return function(val) {
            if (!letter) {
                return val;
            }
            return val.text.toLowerCase().startsWith(letter.toLowerCase()) ? val : '';
        };
    }

    function contains(letter) {
        return function(val) {
            if (!letter) {
                return val;
            }
            return val.text.toLowerCase().includes(letter.toLowerCase()) ? val : '';
        };
    }

    function loadMoreItems() {
        vm.infiniteScroll.listLimit += vm.infiniteScroll.numberToAdd;
    }

    function initListLimit() {
        return vm.model ? getSelectedValueIndex() : INITIAL_ITEMS_COUNT;
    }

    function getSelectedValueIndex() {
        const selectedValueIndex = vm.list.findIndex((item) => item && item.value === vm.model.value);
        return selectedValueIndex < INITIAL_ITEMS_COUNT
            ? INITIAL_ITEMS_COUNT
            : selectedValueIndex + 1;
    }

    function onOpenClose(isOpen) {
        if (!isOpen && !vm.model) {
            vm.infiniteScroll.listLimit = vm.infiniteScroll.numberToAdd;
        }
    }

    function checkPaymentCode(value) {
        if ($rootScope.approversPaymentCodeId === parseInt(vm.id)) {
            $rootScope.$broadcast(tripEvents.CLEAR_APPROVER, {item: value, dropdownId: vm.id});
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/common/typeahead-dropdown/typeahead-dropdown-component.js